import { AppShell } from '../shell/app-shell';

export function AppLayoutRoute() {
  return <AppShell />;
}
